import { createReducer } from 'redux-create-reducer';
import { clueTenStepDefault } from '../../../constant/clue';
import callAPI from '../../../utils/callAPI';

export const INIT_CLUE_TEN_STEP = 'INIT_CLUE_TEN_STEP';
export const UPDATE_CLUE_BY_STEP = 'UPDATE_CLUE_BY_STEP';
export const UPDATE_CLUE_BY_CURRENT_STEP = 'UPDATE_CLUE_BY_CURRENT_STEP';
export const UPDATE_CLUE_CURRENT_STEP_INDEX = 'UPDATE_CLUE_CURRENT_STEP_INDEX';

export const ACTION_CREATE_CLUE_TEN_STEP = 'ACTION_CREATE_CLUE_TEN_STEP';
export const REQUEST_CREATE_CLUE_TEN_STEP = 'REQUEST_CREATE_CLUE_TEN_STEP';
export const REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS = 'REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS';
export const REQUEST_CREATE_CLUE_TEN_STEP_FAILURE = 'REQUEST_CREATE_CLUE_TEN_STEP_FAILURE';

export const ACTION_CREATE_CLUE_TEN_STEP_SKIP = 'ACTION_CREATE_CLUE_TEN_STEP_SKIP';
export const REQUEST_CREATE_CLUE_TEN_STEP_SKIP = 'REQUEST_CREATE_CLUE_TEN_STEP_SKIP';
export const REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP =
  'REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP';
export const REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP =
  'REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP';

export const REQUEST_FETCH_LIST_COUNTRY = 'clueTenStep_REQUEST_FETCH_LIST_COUNTRY';
export const REQUEST_FETCH_LIST_COUNTRY_SUCCESS = 'clueTenStep_REQUEST_FETCH_LIST_COUNTRY_SUCCESS';
export const REQUEST_FETCH_LIST_COUNTRY_FAILURE = 'clueTenStep_REQUEST_FETCH_LIST_COUNTRY_FAILURE';

const defaultState = {
  clueTenSteps: [],
  currentStepIndex: 0,
  skipTenClue: false,

  createClueTenStepLoading: false,
  createClueTenStepFailed: false,
  completedCreatedClue: false,
};

const reducer = createReducer(defaultState, {
  [INIT_CLUE_TEN_STEP]: (state, _action) => ({
    ...state,
    skipTenClue: false,
    clueTenSteps: clueTenStepDefault,
    currentStepIndex: 0,
  }),
  [UPDATE_CLUE_BY_STEP]: (state, action) => ({
    ...state,
    clueTenSteps: state?.clueTenSteps?.map((clue, index) => {
      return index === action?.payload?.index ? { ...clue, ...action?.payload?.stepData } : clue;
    }),
  }),
  [UPDATE_CLUE_BY_CURRENT_STEP]: (state, action) => ({
    ...state,
    clueTenSteps: state?.clueTenSteps?.map((clue, index) => {
      return index === state?.currentStepIndex ? Object.assign(clue, action?.payload) : clue;
    }),
  }),
  [UPDATE_CLUE_CURRENT_STEP_INDEX]: (state, action) => ({
    ...state,
    currentStepIndex: action?.payload,
  }),

  [REQUEST_CREATE_CLUE_TEN_STEP]: (state, _action) => ({
    ...state,
    createClueTenStepLoading: true,
    createClueTenStepFailed: false,
    skipTenClue: false,
  }),
  [REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS]: (state, action) => ({
    ...state,
    treasure: action.payload?.data,
    createClueTenStepLoading: false,
    createClueTenStepFailed: false,
    skipTenClue: false,
  }),
  [REQUEST_CREATE_CLUE_TEN_STEP_FAILURE]: (state, _action) => ({
    ...state,
    createClueTenStepLoading: false,
    createClueTenStepFailed: true,
    skipTenClue: false,
  }),
  [REQUEST_CREATE_CLUE_TEN_STEP_SKIP]: (state, _action) => ({
    ...state,
    skipTenClue: true,
    createClueTenStepLoading: true,
    createClueTenStepFailed: false,
  }),
  [REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP]: (state, action) => ({
    ...state,
    skipTenClue: true,
    treasure: action.payload?.data,
    createClueTenStepLoading: false,
    createClueTenStepFailed: false,
    completedCreatedClue: true,
  }),
  [REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP]: (state, _action) => ({
    ...state,
    skipTenClue: false,
    createClueTenStepLoading: false,
    createClueTenStepFailed: true,
  }),
  [REQUEST_FETCH_LIST_COUNTRY]: (state, _action) => ({
    ...state,
    fetchListCountryLoading: true,
    fetchListCountryFailed: false,
  }),
  [REQUEST_FETCH_LIST_COUNTRY_SUCCESS]: (state, action) => ({
    ...state,
    countries: [{ id: '', iso: '', name: 'All Country' }, ...(action.payload?.data?.items || [])],
    fetchListCountryLoading: false,
    fetchListCountryFailed: false,
  }),
  [REQUEST_FETCH_LIST_COUNTRY_FAILURE]: (state, _action) => ({
    ...state,
    fetchListCountryLoading: false,
    fetchListCountryFailed: true,
  }),
});

export default reducer;
export const namespace = 'clueTenStep';

export const initClueTenStep = (payload) => ({
  type: INIT_CLUE_TEN_STEP,
  payload: payload,
});

export const updateClueStepData = (index, payload) => ({
  type: UPDATE_CLUE_BY_STEP,
  payload: { index, stepData: payload },
});

export const updateClueCurrentStepData = (payload) => ({
  type: UPDATE_CLUE_BY_CURRENT_STEP,
  payload: payload,
});

export const updateClueCurrentStepIndex = (payload) => ({
  type: UPDATE_CLUE_CURRENT_STEP_INDEX,
  payload: payload,
});

export const createClueTenStep = (payload) => ({
  type: ACTION_CREATE_CLUE_TEN_STEP,
  payload: payload,
});

export const createClueTenStepSkip = (payload) => ({
  type: ACTION_CREATE_CLUE_TEN_STEP_SKIP,
  payload: payload,
});

export const createClueTenStepAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: `clues/ten-step`,
    actionTypes: [
      REQUEST_CREATE_CLUE_TEN_STEP,
      REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS,
      REQUEST_CREATE_CLUE_TEN_STEP_FAILURE,
    ],
    variables: payload,
    dispatch,
    getState,
  });
};

export const createClueTenStepSkipAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: `clues/ten-step`,
    actionTypes: [
      REQUEST_CREATE_CLUE_TEN_STEP_SKIP,
      REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP,
      REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP,
    ],
    variables: payload,
    dispatch,
    getState,
  });
};

export const fetchListCountry = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/countries`,
    actionTypes: [
      REQUEST_FETCH_LIST_COUNTRY,
      REQUEST_FETCH_LIST_COUNTRY_SUCCESS,
      REQUEST_FETCH_LIST_COUNTRY_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};
